module.exports = __webpack_public_path__ + "assets/fonts/EBGaramond-Bold.fb6f0218.ttf";